import { Link } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import { useAuth } from "../context/AuthContext";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

function isSectionHeader(line) {
  const t = line.trim();
  if (!t || t.length > 70) return false;
  const capsRatio = (t.match(/[A-Z]/g) || []).length / (t.replace(/\s/g, "").length || 1);
  return capsRatio >= 0.6 || /^(LAST UPDATED|CONTACT US|HOW TO)/i.test(t);
}

export default function LegalDocument({ pageTitle, content }) {
  const auth = useAuth();
  const hasAppShell = Boolean(auth?.profile?.accessToken);
  const lines = (content || "").split("\n");

  const documentContent = (
    <div className="max-w-4xl mx-auto py-6 overflow-y-auto">
      <div className="prose prose-invert max-w-none">
        {lines.map((line, i) => {
          const trimmed = line.trim();
          if (!trimmed) return <div key={i} className="h-3" />;
          if (/^LAST UPDATED:/i.test(trimmed)) {
            return (
              <p key={i} className="text-gray-400 text-sm mb-6">
                {trimmed}
              </p>
            );
          }
          if (isSectionHeader(trimmed)) {
            return (
              <h2
                key={i}
                className="text-xl font-semibold text-[#ceb46a] mt-8 mb-3 border-b border-gray-600 pb-2"
              >
                {trimmed}
              </h2>
            );
          }
          return (
            <p key={i} className="text-gray-300 text-[15px] leading-relaxed mb-3">
              {trimmed}
            </p>
          );
        })}
      </div>
    </div>
  );

  if (!hasAppShell) {
    return (
      <div className="min-h-screen bg-black px-4 py-8 text-white sm:px-8">
        <div className="mx-auto max-w-5xl">
          <header className="mb-8 flex flex-col gap-4 border-b border-gray-800 pb-5 sm:flex-row sm:items-center sm:justify-between">
            <Link to="/login" className="inline-flex items-center">
              <img src={Logo} alt="Select Exposure" className="w-[240px] max-w-full" />
            </Link>
            <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm font-medium text-gray-300">
              <Link to="/login" className="hover:text-[#ceb46a]">
                Login
              </Link>
              <Link to="/signup" className="hover:text-[#ceb46a]">
                Sign Up
              </Link>
              <Link to="/faqs" className="hover:text-[#ceb46a]">
                FAQs
              </Link>
            </nav>
          </header>
          <h1 className="mb-6 text-3xl font-bold text-[#ceb46a]">{pageTitle}</h1>
          {documentContent}
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 p-6 lg:ml-64">
        <Topbar pageTitle={pageTitle} />
        {documentContent}
      </div>
    </div>
  );
}
